import { render } from "./PerkConfigs.vue?vue&type=template&id=7ec47bf5&scoped=true"
import script from "./PerkConfigs.vue?vue&type=script&lang=js"
export * from "./PerkConfigs.vue?vue&type=script&lang=js"

import "./PerkConfigs.vue?vue&type=style&index=0&id=7ec47bf5&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec47bf5"]])

export default __exports__